import { render } from "./ContentBlock.vue?vue&type=template&id=f8e52cb4&scoped=true"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"

import "./ContentBlock.vue?vue&type=style&index=0&id=f8e52cb4&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e52cb4"]])

export default __exports__